export const HOST_API = process.env.HOST_API || process.env.NODE_ENV === "development" ? "http://localhost:8081" : "https://vradio.me/";
export const APP_NAME = "vRadio - Thanh âm cảm xúc";

export const APP_TITLE = " | " + APP_NAME;